import { Box } from "@mui/material";
import styles from "../../Styles/examImage.module.css";

export default function ExamImage({
  imageUrl,
  maxHeight,
  maxWidth,
}: {
  imageUrl?: string;
  maxHeight?: string;
  maxWidth?: string;
}) {
  if (!imageUrl) return null;

  const customStyle = maxHeight || maxWidth ? {
    maxHeight: maxHeight,
    maxWidth: maxWidth,
  } : undefined;

  return (
    <Box className={styles.imageContainer}>
      <img
        src={"/" + imageUrl}
        alt="question"
        className={styles.questionImage}
        style={customStyle}
      />
    </Box>
  );
}
